import React, { useState, useEffect } from 'react';
import includes from 'lodash/includes';
import { Grid, Button, Typography } from '@mui/material';

import FilterChip from '../../common/filter-chip';

function toggleFilterValue(filters, value) {
  if (includes(filters, value)) {
    return filters.filter((s) => s !== value);
  } else {
    return filters.concat(value);
  }
}

function toggleAll(defaultValues, filters) {
  if (filters && filters.length !== defaultValues.length) return defaultValues;
  return [];
}

function VehicleFilterChips(props) {
  const {
    onChange, rowLabel, chipValues, getChipLabel, selectedFilters, toggleAllLabel,
  } = props;
  const [filters, setFilters] = useState(selectedFilters);
  useEffect(() => onChange(filters), [filters]);
  return (
    <Grid container alignItems="center">
      <Grid item xs={12} sm={1} sx={{ minWidth: 100 }}>
        <Typography variant="body2"><strong>{rowLabel}</strong></Typography>
      </Grid>
      <Grid item xs={12} sm={11} sx={{ maxWidth: { xs: 1, sm: 'calc(100% - 100px)' } }}>
        {chipValues.map((value) => (
          <FilterChip
            key={value}
            label={getChipLabel(value)}
            value={value}
            selected={includes(filters, value)}
            onClick={() => {
              setFilters(toggleFilterValue(filters, value));
            }}
          />
        ))}
        <Button size="small" type="outlined" color="primary" onClick={() => setFilters(toggleAll(chipValues, filters))}>
          {toggleAllLabel}
        </Button>
      </Grid>
    </Grid>
  );
}

export default VehicleFilterChips;
